import { L, vocabulary } from '../define.js';
export const IDENTITY_VOCABULARIES = [
    vocabulary('identity.user_status', '@vello/identity USER_STATUSES', {
        ACTIVE: L('Ativa', 'Active', 'Activa', 'Attivo'),
        SUSPENDED: L('Suspensa', 'Suspended', 'Suspendida', 'Sospeso'),
        DELETED: L('Excluída', 'Deleted', 'Eliminada', 'Eliminato'),
    }),
];
//# sourceMappingURL=identity.js.map